import RosterQrCodeOnboard from './RosterQrCodeOnboard';

export default RosterQrCodeOnboard;
